module.exports = __webpack_public_path__ + "img/bgDownload.69f4e957.jpg";